import gql from 'graphql-tag';

export const GET_ADOPTION_ACCOUNTS = gql`
  query getAdoptionAccounts($urlCode: String!) {
    publicAdoptionEvent(urlCode: $urlCode) {
      adoptionAccounts {
        districtId
        name
      }
    }
  }
`;
